import './index.scss';
import React from 'react';
import { Link } from 'gatsby';
import PhoneChatbot from '../../assets/phone_chatbot.png'

const FeatureOverview = () => {
  return (
    <div className="featureoverview">
      <div className="container">
        <h2>Funktionsumfang</h2>
        <div className="featureoverview__content">
          <div className="featureoverview__grid">
            <div className="featureoverview__card featureoverview__card--highlight">
              <h3>Zugeschnittener Chatbot</h3>
              <p>
                Versteht die Inhalte Ihrer Website bis ins Detail – inklusive PDF-Dokumenten (je nach Paket). Der Chatbot analysiert sämtliche Inhalte, passt sich Ihrem Unternehmen an und antwortet präzise in natürlicher Sprache.
              </p>
              <div className="featureoverview__image">
                <img src={PhoneChatbot} alt="holzweg Chatbot mobile Ansicht" />
              </div>
            </div>

            <div className="featureoverview__card">
              <h3>Performance-Monitoring</h3>
              <p>
                Liefert präzise Einblicke in das Nutzerverhalten – inklusive Anzahl der Anfragen, häufig gestellter Fragen und Interaktionsverläufen. So erkennen Sie Optimierungspotenziale und verstehen, was Ihre Website-Besucher wirklich interessiert.
              </p>
            </div>

            <div className="featureoverview__card">
              <h3>Intelligente Suche</h3>
              <p>
                Versteht Suchanfragen in natürlicher Sprache und liefert gezielte Ergebnisse – flexibler als klassische Schlagwortsuche. Kann als eigenständige Komponente eingebunden werden und herkömmliche Suchfunktionen vollständig ersetzen.
              </p>
            </div>

            <div className="featureoverview__card">
              <h3>Mehrsprachig & Verständig</h3>
              <p>
                Versteht auch unklare oder vage formulierte Anfragen zuverlässig – ganz gleich, worum es geht. Kommuniziert fließend in über 50 Sprachen, selbst wenn Ihre Website nur in einer Sprache verfügbar ist.
              </p>
            </div>

            <div className="featureoverview__card">
              <h3>CI-konform einsetzbar</h3>
              <p>
                Fügt sich nahtlos in Ihr Design ein – vom Logo über Farben bis zur gewünschten Sprache und Tonalität. Der Chatbot lässt sich weitestgehend an Ihre Corporate Identity anpassen und wirkt so wie ein Teil Ihres Teams.
              </p>
            </div>
          </div>
        </div>

        <div className="featureoverview__button-wrapper">
          <div className="featureoverview__button">
            <Link to="#chatbotdemo" className="button button--color-black">
              Demo anfordern
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureOverview;
